import { render, staticRenderFns } from "./Account_Statement.vue?vue&type=template&id=36b1bfb4&scoped=true&"
import script from "./Account_Statement.vue?vue&type=script&lang=js&"
export * from "./Account_Statement.vue?vue&type=script&lang=js&"
import style0 from "./Account_Statement.vue?vue&type=style&index=0&id=36b1bfb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b1bfb4",
  null
  
)

export default component.exports